/* Assets */
import { addItemToSessionStorage } from '@/assets/scripts/windowStorage'
import { USER_SESSION } from '@/assets/constants/core'

/** saves the user data from the login service
@payload { object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authentication
*/
export const SAVE_USER_INFO = (state, payload) => {
    const userDefaultPreferencePickedForSession = payload.accountGroups.find(obj => obj.userDefaultPreference) ||
    payload.accountGroups.filter(obj => obj.type === 'COMPANY').length === 1

    state.allUserInfo = {
        ...payload,
        acessionNumber: payload.customer.username,
        userDefaultPreferencePickedForSession: userDefaultPreferencePickedForSession
    }
    state.userSession = payload.session

    addItemToSessionStorage(USER_SESSION, state.allUserInfo)
}

/** updates session out Of Band Validation Type
@payload {string} - [ussd, email]
*/
export const SAVE_OUT_OF_BAND_VALIDATION_TYPE = (state, payload) => {
    state.outOfBandValidationType = payload
}

/** updates session expired state
@payload {Boolean} - session expired state
*/
export const UPDATE_SESSION_EXPIRE_STATE = (state, payload) => {
    state.sessionExpired = payload
}

/** updates session timer and triggers session expire state
@payload {Boolean} - session expired state
*/
export const UPDATE_SESSION_TIMER = (state, payload) => {
    state.sessionTimer = payload
    if (payload < 1) state.sessionExpired = true
}

/** saves the user data from the login service
@payload { object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authentication
*/
export const UPDATE_REMAINING_SECONDS_FOR_SESSION_EXPIRE = (state, payload) => {
    const remainingSeconds = payload || state.userSession.remainingSecondsForSessionExpire
    const currentTime = new Date().getTime()
    const expiryDate = new Date()

    expiryDate.setTime(currentTime + remainingSeconds * 1000)
    state.localExpiryDate = expiryDate.getTime()
    state.localExpirySpan = ((state.localExpiryDate - currentTime) / 1000)
}

/** saves the entity remember me info in our store and localStorage
@payload { object }
*/
export const UPDATE_ENTITY_REMEMBER_ME_INFO = (state, payload) => {
    if (payload.requiresOutOfBandSessionAuthentication) {
        state.savedEntityTillOutOfBandValidation = payload
        return
    }

    state.savedEntityTillOutOfBandValidation = null
    if (!state.rememberMeEntityInfo) {
        state.rememberMeEntityInfo = {
            entity: payload.entity,
            entityName: payload.entityName,
            listOfAcessions: [{ ...payload.acession }]
        }
    } else {
        if (!state.rememberMeEntityInfo.listOfAcessions.find(obj => obj.acessionNumber === payload.acession.acessionNumber)) {
            state.rememberMeEntityInfo.listOfAcessions.push(payload.acession)
        }
    }
    window.localStorage.setItem(`bai-remember-me-entity-info-${state.currentAppThemeClientType}`, JSON.stringify(state.rememberMeEntityInfo))
}

/** updates the selected acession
@payload {String, Number} - accessionNumber we want to mark as selected
*/
export const UPDATE_SELECTED_ENTITY_REMEMBER_ME_INFO = (state, payload) => {
    state.rememberMeEntityInfo.listOfAcessions.map(el => {
        el.selected = el.acessionNumber === payload
    })
}

/** updates the selected acession theme
@payload {Object} - All info saved in store with exchanges
*/
export const UPDATE_ENTITY_REMEMBER_INFO = (state, payload) => {
    state.rememberMeEntityInfo = payload
    window.localStorage.setItem(`bai-remember-me-entity-info-${state.currentAppThemeClientType}`, JSON.stringify(state.rememberMeEntityInfo))
}

/** updates the selected acession theme
@payload {String} - current theme [dark, light]
*/
export const UPDATE_SELECTED_ENTITY_THEME = (state, payload) => {
    if (!state.rememberMeEntityInfo) return

    state.rememberMeEntityInfo.listOfAcessions = state.rememberMeEntityInfo.listOfAcessions.map(el => {
        return { ...el, selectedAppTheme: payload }
    })

    /* If no acessions are saved, we delete entity info from store and localStorage */
    if (!state.rememberMeEntityInfo.listOfAcessions.length) state.rememberMeEntityInfo = null

    window.localStorage.setItem(`bai-remember-me-entity-info-${state.currentAppThemeClientType}`, JSON.stringify(state.rememberMeEntityInfo))
}

/** removes acession from our entity remember me info, and updates it our store and localStorage
@payload { object }
*/
export const REMOVE_ACESSION_FROM_ENTITY_REMEMBER_ME_INFO = (state, payload) => {
    state.rememberMeEntityInfo.listOfAcessions = state.rememberMeEntityInfo.listOfAcessions.filter(obj => obj.acessionNumber !== payload)
    /* If no acessions are saved, we delete entity info from store and localStorage */
    if (!state.rememberMeEntityInfo.listOfAcessions.length) state.rememberMeEntityInfo = null

    window.localStorage.setItem(`bai-remember-me-entity-info-${state.currentAppThemeClientType}`, JSON.stringify(state.rememberMeEntityInfo))
}

/** saves the selected account group
@payload { object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationsetSessionContractAccountGroup
*/
export const SAVES_CURRENT_SELECTED_ACCOUNT_GROUP = (state, payload) => {
    state.allUserInfo = {
        ...state.allUserInfo,
        userDefaultPreferencePickedForSession: true,
        accountGroups: state.allUserInfo.accountGroups.map(account => {
            return {
                ...account,
                default: account.id === payload.groupId
            }
        })
    }
    addItemToSessionStorage(USER_SESSION, state.allUserInfo)
}

/** saves list of popups for this session
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetpopup
*/
export const SAVES_POPUPS_LIST = (state, payload) => {
    if (payload.length) state.showPopupsList = true
    state.popupsList = payload
}

/** Clear list of popups for this session
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetpopupdismiss
*/
export const CLEAR_POPUPS_LIST = state => {
    state.showPopupsList = false
    state.popupsList = []
}

/** Updates Customer Image Url
@payload { String } -
*/
export const UPDATE_CUSTOMER_IMAGE_URL = (state, payload) => {
    state.allUserInfo.customer.avatarImageUrl = payload

    if (state.rememberMeEntityInfo) {
        state.rememberMeEntityInfo.listOfAcessions = state.rememberMeEntityInfo.listOfAcessions.map(acession => {
            return {
                ...acession,
                avatarImageUrl: acession.username === state.allUserInfo.acessionNumber ? state.allUserInfo.customer.avatarImageUrl : acession.avatarImageUrl
            }
        })

        addItemToSessionStorage(USER_SESSION, state.allUserInfo)
        window.localStorage.setItem(`bai-remember-me-entity-info-${state.currentAppThemeClientType}`, JSON.stringify(state.rememberMeEntityInfo))
    }
}

/** Updates MOBILE BIOMETRIC
@payload { String } - [face, finger (or in more recents androids returns biometric)]
*/
export const UPDATE_MOBILE_BIOMETRIC = (state, payload) => {
	state.mobileBiometric = payload
}

/** saves the user data from the login service
@payload { object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authentication
*/
export const UPDATE_SESSION_VALIDATION = (state, payload) => {
    const userData = JSON.parse(window.sessionStorage.getItem(USER_SESSION))

    if (userData) {
        state.allUserInfo = {
            ...state.allUserInfo,
            requiresOutOfBandSessionAuthentication: payload.data.status !== 'VALID'
        }

        window.sessionStorage.setItem(USER_SESSION, JSON.stringify(state.allUserInfo))
    }
}

export const UPDATE_INITIAL_ACTIONS = (state, payload) => {
    const userData = JSON.parse(window.sessionStorage.getItem(USER_SESSION))
    if (userData) {
        state.allUserInfo = {
            ...state.allUserInfo,
            initialActions: state.allUserInfo.initialActions.filter(el => el.type !== payload)
        }

        window.sessionStorage.setItem(USER_SESSION, JSON.stringify(state.allUserInfo))
    }
}

export const UPDATE_SESSION_TYPE = (state, payload) => {
    const userData = JSON.parse(window.sessionStorage.getItem(USER_SESSION))
    if (userData) {
        state.allUserInfo = {
            ...state.allUserInfo,
            isCompany: !state.allUserInfo.isCompany
        }

        window.sessionStorage.setItem(USER_SESSION, JSON.stringify(state.allUserInfo))
    }
}
